































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Data from "../../../store/entities/data";
class PagefactoryRequest{
}
@Component
export default class EditSmokecrib extends AbpBase {
  pagefactoryrequest: PagefactoryRequest = new PagefactoryRequest();
  @Prop({ type: Boolean, default: false }) value: boolean;
  created() {}
  data: Data = new Data();
  imgpath="";
  save() {
    (this.$refs.picForm as any).validate(async (valid: boolean) => {
      if (valid) {
        (this.$refs.picForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
        this.imgpath = ""; 
      }
    });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      this.imgpath = "";
    } else {
      this.data = Util.extend(true, {}, this.$store.state.data.editStatus);
      if(this.data["path"] != null && this.data["path"] != undefined && this.data["path"] != ""){
         this.imgpath = "https://api.ep.zhiliaoep.com" + this.data["path"];
    }
      }
    
  }
}
